<template>
	<div class="login-frame">
		<Form class="root-forget-account" ref="loginForm" :model="form" :rules="{}" :validOnChange="true">
			<FormItem :showLabel="false" required prop="mobile" label="账号">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-user"></i>
					<Input v-model="form.mobile" type="text" placeholder="请输入手机号" class="forget-input"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" required prop="code" label="验证码">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-check-circle"></i>
					<Input v-model="form.code" type="text" placeholder="请输入验证码" maxlength="4" style="width: 68%" class="forget-input"/>
					<SmsVerificationCode :mobile="form.mobile" class="forget-input"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" required prop="newPassword" label="新密码">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-lock"></i>
					<Input type="password" placeholder="请输入新密码" v-model="form.newPassword" autocomplete="off" class="forget-input"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" required prop="repeatPassword" label="确认新密码">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-lock"></i>
					<Input type="password" placeholder="请再次输入新密码" v-model="form.repeatPassword" autocomplete="off" class="forget-input"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" class="!pb-0px">
				<Button @click="regSubmit" :loading="loading" class="root-forget-btn" block>修 改 密 码</Button>
				<div class=" my-16px">
					<span class="text-hover" style="color: #9b9ea0;" @click="$emit('changeView','LoginForm')">返回登录</span>
				</div>
			</FormItem>
		</Form>
	</div>
</template>
<script>
	import SmsVerificationCode from "../../components/SmsVerificationCode"

	export default {
		name: 'ForgotPassword',
		components: {SmsVerificationCode},
		data() {
			return {
				form: {
					mobile: "",
					code: "",
					newPassword: "",
					repeatPassword: "",
				},
				loading: false
			};
		},
		methods: {
			regSubmit() {
				let validResult = this.$refs.loginForm.valid();
				if (validResult.result) {
					this.loading = true;
					this.$api.common.resetPassword(this.form).then(() => {
						this.$Message("密码重置成功！");
						this.$emit('input', 'LoginForm');
					}).finally(() => {
						this.loading = false;
					});
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.root-forget-account {
		margin-top: 30px;
	}

	.forget-input {
		height: 45px;
		border-radius: 6px;
	}
	.root-forget-btn {
		height: 40px;
		background-color: #006dfd;
		border-radius: 20px;
		color: #fff;
		cursor: default;
		width: 100%;
	}
	.root-forget-btn:hover, .root-forget-btn:focus {
		background-color: #006dfd;
		border-radius: 20px;
		color: #fff;
	}
</style>
